// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductTable_container__3zfb_","ticketTable":"ProductTable_ticketTable__3fYmq","noTickets":"ProductTable_noTickets__3U5Rn"};